import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Css/MRStore.css';

const STORE_ID = '1758728735874';
const fallbackImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/wcAAwAB/irl6QAAAAASUVORK5CYII=";

const generateRandomPrice = () => {
  const prices = [];
  for (let i = 300; i <= 1000; i += 10) {
    prices.push(i);
  }
  return prices[Math.floor(Math.random() * prices.length)];
};

const MRStore = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [heroItem, setHeroItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadStoreData = async () => {
      try {
        const storeDocRef = `https://firestore.googleapis.com/v1/projects/xyronis-8cc09/databases/(default)/documents/stores/${STORE_ID}`;

        const response = await fetch(storeDocRef, {
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Store not found');
        }

        const doc = await response.json();
        const fields = doc.fields;

        const storeItems = (fields.items?.arrayValue?.values || []).map(itemValue => {
          const itemFields = itemValue.mapValue.fields;
          return {
            id: itemFields.id.stringValue,
            itemName: itemFields.itemName.stringValue,
            glbUrl: itemFields.glbUrl.stringValue,
            imageUrl: itemFields.imageUrl?.stringValue || null,
            timestamp: itemFields.timestamp.stringValue,
            category: itemFields.category?.stringValue || 'Furniture',
            price: generateRandomPrice(),
          };
        });

        setItems(storeItems);

        if (storeItems.length > 0) {
          const specificHeroItem = storeItems.find(item => item.itemName === 'PUT_EXACT_ITEM_NAME_HERE');
          setHeroItem(specificHeroItem || storeItems[0]);
        }
      } catch (error) {
        console.error('Error loading store:', error);
      } finally {
        setLoading(false);
      }
    };

    loadStoreData();
  }, []);

  const launchMrDemo = () => {
    console.log('DEBUG: Launching Mixed Reality Store');
    const specificStoreUrl = `https://xyronis.xyz/mr-demo?storeId=${STORE_ID}`;

    if (navigator.xr) {
      navigator.xr.isSessionSupported('immersive-ar')
        .then(supported => {
          console.log('DEBUG: WebXR supported:', supported);
          if (supported) {
            window.location.href = specificStoreUrl;
          } else {
            window.open(
              'https://www.oculus.com/open_url/?url=' + encodeURIComponent(specificStoreUrl),
              '_blank'
            );
          }
        })
        .catch(err => {
          console.error('Error checking WebXR support:', err);
          window.open(
            'https://www.oculus.com/open_url/?url=' + encodeURIComponent(specificStoreUrl),
              '_blank'
            );
        });
    } else {
      console.log('DEBUG: No WebXR support');
      window.open(
        'https://www.oculus.com/open_url/?url=' + encodeURIComponent(specificStoreUrl),
        '_blank'
      );
    }
  };

  if (loading) {
    return <div className="mr-store-container">Loading...</div>;
  }

  return (
    <div className="mr-store-container">
      <section className="hero-section">
        <div className="hero-text">
          <h1 className="hero-title">
            Explore home improvement products in <span>Mixed Reality</span>
          </h1>
          <div className="hero-button-container">
            <button onClick={launchMrDemo} className="cta-button">
              Launch Mixed Reality Store
            </button>
          </div>
        </div>
        <div className="hero-image-container">
          <img
            src={heroItem?.imageUrl || fallbackImage}
            alt={heroItem?.itemName || "Hero"}
            className="hero-image"
          />
        </div>
      </section>
      <section className="featured-section">
        <h2 className="featured-title">Featured Collection</h2>
        <p className="featured-subtext">
          See them in Mixed Reality in real life dimensions
        </p>
        <div className="featured-grid">
          {items.map((item) => (
            <div key={item.id} className="featured-item">
              <img src={item.imageUrl || fallbackImage} alt={item.itemName} />
              <h3 className="item-title">{item.itemName}</h3>
              <p className="item-price">${item.price}</p>
              <p className="item-description">{item.category}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default MRStore;